import type { OrderRecord } from "@/types";

export const orders: OrderRecord[] = [
  {
    id: "1045",
    branch: "فرع العليا",
    customer: "ماجد العنزي",
    phone: "0554445566",
    timeAgo: "منذ 40 دقيقة",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٠٥ م",
    items: 3,
    amount: 140.5,
    status: "received",
    pickup: "delivery",
    payment: "card",
    source: "app",
    appFee: 0.8,
    deliveryFee: 15,
    note: "عنوان التوصيل: حي العليا، طريق الملك فهد، برج المكاتب",
    debtRecorded: false,
    activity: [
      { label: "تم استلام طلب التوصيل من التطبيق", time: "٩:٠٥ م" },
      { label: "بدء تحضير الطلب", time: "٩:٠٦ م" },
      { label: "الطلب قارب على الانتهاء", time: "٩:١٥ م" },
      { label: "الطلب جاهز للتوصيل", time: "٩:٢٠ م" },
      { label: "الطلب خرج للتوصيل", time: "٩:٢٤ م" },
      { label: "تم تسليم الطلب", time: "٩:٤٠ م" },
    ],
    lines: [
      { name: "مندي لحم", quantity: 1, price: 65 },
      { name: "برياني دجاج", quantity: 1, price: 38 },
      { name: "لقيمات", quantity: 1, price: 14 },
    ],
  },
  {
    id: "1056",
    branch: "فرع العليا",
    customer: "لطيفة الدوسري",
    phone: "0552223344",
    timeAgo: "منذ لحظات",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٤٨ م",
    items: 2,
    amount: 125.8,
    status: "new",
    pickup: "delivery",
    payment: "card",
    source: "app",
    appFee: 0.8,
    deliveryFee: 15,
    note: "عنوان التوصيل: حي العليا، شارع التحلية، مبنى ١٢",
    debtRecorded: false,
    activity: [{ label: "تم استلام طلب التوصيل من التطبيق", time: "٩:٤٨ م" }],
    lines: [
      { name: "مندي لحم", quantity: 1, price: 65 },
      { name: "كبسة دجاج", quantity: 1, price: 45 },
    ],
  },
  {
    id: "1055",
    branch: "فرع الملقا",
    customer: "عبدالله المطيري",
    phone: "0559871234",
    timeAgo: "منذ دقيقة",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٤٥ م",
    items: 3,
    amount: 78.2,
    status: "new",
    pickup: "branch",
    payment: "cash",
    source: "branch",
    appFee: 0,
    note: "سفرة عائلية — من فضلكم أدوات إضافية",
    debtRecorded: false,
    activity: [{ label: "تم استلام الطلب", time: "٩:٤٥ م" }],
    lines: [
      { name: "كبسة دجاج", quantity: 1, price: 45 },
      { name: "حمص بالطحينة", quantity: 1, price: 15 },
      { name: "شاي بالنعناع", quantity: 1, price: 8 },
    ],
  },
  {
    id: "1054",
    branch: "فرع العليا",
    customer: "سعد الحربي",
    phone: "0551234567",
    timeAgo: "منذ 3 دقائق",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٤٢ م",
    items: 4,
    amount: 113.8,
    status: "new",
    pickup: "car",
    payment: "card",
    source: "app",
    appFee: 0.8,
    note: "بدون بصل في السمبوسة",
    debtRecorded: false,
    activity: [{ label: "تم استلام الطلب من التطبيق", time: "٩:٤٢ م" }],
    lines: [
      { name: "كبسة دجاج", quantity: 2, price: 45 },
      { name: "حمص بالطحينة", quantity: 1, price: 15 },
      { name: "شاي بالنعناع", quantity: 1, price: 8 },
    ],
  },
  {
    id: "1053",
    branch: "فرع النخيل",
    customer: "نورة القحطاني",
    phone: "0553219876",
    timeAgo: "منذ 6 دقائق",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٣٩ م",
    items: 2,
    amount: 69,
    status: "preparing",
    pickup: "branch",
    payment: "applepay",
    source: "app",
    appFee: 0.8,
    debtRecorded: false,
    activity: [
      { label: "تم استلام الطلب من التطبيق", time: "٩:٣٩ م" },
      { label: "بدء تحضير الطلب", time: "٩:٤٠ م" },
    ],
    lines: [
      { name: "برياني دجاج", quantity: 1, price: 38 },
      { name: "شاي بالنعناع", quantity: 1, price: 8 },
      { name: "لقيمات", quantity: 1, price: 14 },
    ],
  },
  {
    id: "1052",
    branch: "فرع العليا",
    customer: "فهد الدوسري",
    phone: "0567891234",
    timeAgo: "منذ 9 دقائق",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٣٦ م",
    items: 6,
    amount: 217.75,
    status: "almost",
    pickup: "local",
    payment: "wallet",
    source: "app",
    appFee: 0.8,
    debtRecorded: false,
    activity: [
      { label: "تم استلام الطلب من التطبيق", time: "٩:٣٦ م" },
      { label: "بدء تحضير الطلب", time: "٩:٣٧ م" },
      { label: "الطلب قارب على الانتهاء", time: "٩:٤٤ م" },
    ],
    lines: [
      { name: "مندي لحم", quantity: 2, price: 65 },
      { name: "كبسة دجاج", quantity: 1, price: 45 },
      { name: "حمص بالطحينة", quantity: 1, price: 15 },
      { name: "ليمون بالنعناع", quantity: 2, price: 12 },
    ],
  },
  {
    id: "1051",
    branch: "فرع الملقا",
    customer: "ريم العتيبي",
    phone: "0509876543",
    timeAgo: "منذ 12 دقيقة",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٣٣ م",
    items: 3,
    amount: 96,
    status: "ready",
    pickup: "car",
    payment: "cash",
    source: "branch",
    appFee: 0,
    debtRecorded: false,
    activity: [
      { label: "تم استلام الطلب", time: "٩:٣٣ م" },
      { label: "بدء تحضير الطلب", time: "٩:٣٤ م" },
      { label: "الطلب قارب على الانتهاء", time: "٩:٤٠ م" },
      { label: "الطلب جاهز للاستلام", time: "٩:٤٥ م" },
    ],
    lines: [
      { name: "كبسة دجاج", quantity: 1, price: 45 },
      { name: "كنافة بالجبن", quantity: 1, price: 22 },
      { name: "لقيمات", quantity: 1, price: 14 },
      { name: "شاي بالنعناع", quantity: 1, price: 8 },
    ],
  },
  {
    id: "1050",
    branch: "فرع النخيل",
    customer: "خالد الشهري",
    phone: "0534567890",
    timeAgo: "منذ 15 دقيقة",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٣٠ م",
    items: 5,
    amount: 179.25,
    status: "received",
    pickup: "branch",
    payment: "card",
    source: "app",
    appFee: 0.8,
    debtRecorded: false,
    activity: [
      { label: "تم استلام الطلب من التطبيق", time: "٩:٣٠ م" },
      { label: "بدء تحضير الطلب", time: "٩:٣١ م" },
      { label: "الطلب قارب على الانتهاء", time: "٩:٣٨ م" },
      { label: "الطلب جاهز للاستلام", time: "٩:٤٣ م" },
      { label: "تم استلام الطلب من العميل", time: "٩:٥٠ م" },
    ],
    lines: [
      { name: "مندي لحم", quantity: 1, price: 65 },
      { name: "برياني دجاج", quantity: 2, price: 38 },
      { name: "سمبوسة مقرمشة", quantity: 2, price: 12 },
    ],
  },
  {
    id: "1049",
    branch: "فرع العليا",
    customer: "منى الغامدي",
    phone: "0598765432",
    timeAgo: "منذ 18 دقيقة",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٢٧ م",
    items: 1,
    amount: 37,
    status: "new",
    pickup: "local",
    payment: "applepay",
    source: "app",
    appFee: 0.8,
    debtRecorded: false,
    activity: [{ label: "تم استلام الطلب من التطبيق", time: "٩:٢٧ م" }],
    lines: [{ name: "برياني دجاج", quantity: 1, price: 38 }],
  },
  {
    id: "1048",
    branch: "فرع الملقا",
    customer: "أحمد الزهراني",
    phone: "0551112233",
    timeAgo: "منذ 22 دقيقة",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٢٣ م",
    items: 8,
    amount: 310.5,
    status: "ready",
    pickup: "car",
    payment: "wallet",
    source: "app",
    appFee: 0.8,
    note: "الطلب لسيارة فضية أمام البوابة",
    debtRecorded: false,
    activity: [
      { label: "تم استلام الطلب من التطبيق", time: "٩:٢٣ م" },
      { label: "بدء تحضير الطلب", time: "٩:٢٤ م" },
      { label: "الطلب قارب على الانتهاء", time: "٩:٣٥ م" },
      { label: "الطلب جاهز للاستلام", time: "٩:٤٢ م" },
    ],
    lines: [
      { name: "مندي لحم", quantity: 3, price: 65 },
      { name: "كبسة دجاج", quantity: 2, price: 45 },
      { name: "حمص بالطحينة", quantity: 2, price: 15 },
    ],
  },
  {
    id: "1047",
    branch: "فرع النخيل",
    customer: "هند السبيعي",
    phone: "0543334444",
    timeAgo: "منذ 26 دقيقة",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:١٩ م",
    items: 2,
    amount: 53.7,
    status: "missed",
    pickup: "branch",
    payment: "cash",
    source: "app",
    appFee: 0.8,
    vat: 6.9,
    debtRecorded: true,
    debtAmount: 51,
    customerWalletBalance: 20,
    customerTotalDebt: 51,
    activity: [
      { label: "تم استلام الطلب", time: "٩:١٩ م" },
      { label: "بدء تحضير الطلب — تم تسجيل رسوم التطبيق لطلبات الكاش", time: "٩:٢٠ م" },
      { label: "الطلب قارب على الانتهاء", time: "٩:٣٠ م" },
      { label: "الطلب جاهز للاستلام", time: "٩:٣٦ م" },
      {
        label:
          "انتهت مدة السماح دون استلام — تم تسجيل مديونية العميل بقيمة 51.00 ر.س وفق إعدادات قسم المتجر.",
        time: "٩:٥٥ م",
      },
    ],
    lines: [
      { name: "سمبوسة مقرمشة", quantity: 2, price: 12 },
      { name: "كنافة بالجبن", quantity: 1, price: 22 },
    ],
  },
  {
    id: "1046",
    branch: "فرع العليا",
    customer: "بندر العسيري",
    phone: "0566667777",
    timeAgo: "منذ 31 دقيقة",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:١٤ م",
    items: 4,
    amount: 147,
    status: "received",
    pickup: "local",
    payment: "card",
    source: "app",
    appFee: 0.8,
    debtRecorded: false,
    activity: [
      { label: "تم استلام الطلب من التطبيق", time: "٩:١٤ م" },
      { label: "بدء تحضير الطلب", time: "٩:١٥ م" },
      { label: "الطلب قارب على الانتهاء", time: "٩:٢٥ م" },
      { label: "الطلب جاهز للاستلام", time: "٩:٣٠ م" },
      { label: "تم استلام الطلب من العميل", time: "٩:٣٨ م" },
    ],
    lines: [
      { name: "كبسة دجاج", quantity: 2, price: 45 },
      { name: "ليمون بالنعناع", quantity: 2, price: 12 },
      { name: "لقيمات", quantity: 1, price: 14 },
    ],
  },
];